export default {"src":"/_next/static/media/GiraffeFacingLeft.5c3168e9.svg","height":496,"width":236,"blurWidth":0,"blurHeight":0};